(() => {
  if (window.__sapiatoDiscoveryV1) return;
  window.__sapiatoDiscoveryV1 = true;
  const storageKey = 'sapiato-discovery-v1';
  const readState = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      return {seen: state.seen || {}, pages: state.pages || {}};
    } catch (_) { return {seen: {}, pages: {}}; }
  };
  const saveState = state => {
    state.pages = Object.fromEntries(Object.entries(state.pages).slice(-30));
    state.seen = Object.fromEntries(Object.entries(state.seen).sort((a, b) => b[1].time - a[1].time).slice(0, 300));
    try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
  };
  const pick = (pool, seen) => {
    const weights = pool.map(card => Math.sqrt(Math.max(.1, Number(card.dataset.score) || 1)) / (1 + (seen[card.dataset.handle]?.count || 0) * 4));
    let value = Math.random() * weights.reduce((a, b) => a + b, 0);
    return pool.find((card, i) => (value -= weights[i]) <= 0) || pool[pool.length - 1];
  };
  const choose = (pool, count, seen, kind, initial = []) => {
    const chosen = [...initial];
    while (chosen.length < count) {
      let remaining = pool.filter(card => !chosen.includes(card));
      if (!remaining.length) break;
      if (kind === 'discover') {
        const countFamily = card => chosen.filter(p => p.dataset.family === card.dataset.family).length;
        const minimum = Math.min(...remaining.map(countFamily));
        remaining = remaining.filter(card => countFamily(card) === minimum);
      }
      if (chosen.length % 4 === 0) {
        const recent = remaining.filter(card => card.dataset.new === 'true');
        if (recent.length) remaining = recent;
      }
      chosen.push(pick(remaining, seen));
    }
    return chosen;
  };
  const event = (root, name, card) => {
    const payload = {context: 'discovery', experiment: 'discovery_similar_v1', anchor_product: root.dataset.anchor, recommended_product: card.dataset.handle, family: card.dataset.family, kind: card.closest('[data-discovery-group]').dataset.kind, slot: Number(card.dataset.slot)};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(name === 'sapiato_recommendation_impression' ? {event: name, context: 'discovery', anchor_product: root.dataset.anchor, recommendations: [payload]} : {event: name, ...payload});
  };
  const initialize = root => {
    if (root.dataset.discoveryReady) return;
    const state = readState();
    const cacheKey = [root.dataset.anchor, root.dataset.day, root.dataset.signature, root.dataset.maximum].join(':');
    const cached = state.pages[cacheKey];
    const upper = new Set([...document.querySelectorAll('sapiato-complements[data-mode="look"] [data-sx-card]')].filter(card => !card.hidden).map(card => card.dataset.recommendedProduct));
    const groups = [...root.querySelectorAll('[data-discovery-group]')];
    const maximum = Math.min(24, Number(root.dataset.maximum) || 24);
    const used = new Set([root.dataset.anchor]);
    const allSelected = [];
    for (const group of groups) {
      const cards = [...group.querySelectorAll('[data-discovery-card]')];
      const pool = cards.filter(card => !used.has(card.dataset.handle) && !upper.has(card.dataset.handle));
      const count = Math.max(0, Math.min(Number(group.dataset.limit) || 0, maximum - allSelected.length));
      const restored = Array.isArray(cached?.handles) ? cached.handles.map(handle => pool.find(card => card.dataset.handle === handle)).filter(Boolean).slice(0, count) : [];
      const selected = choose(pool, count, state.seen, group.dataset.kind, restored);
      cards.forEach(card => { card.hidden = true; });
      selected.forEach(card => {
        used.add(card.dataset.handle);
        allSelected.push(card);
        card.dataset.slot = String(allSelected.length);
        card.parentElement.appendChild(card);
      });
    }
    const button = root.querySelector('[data-discovery-more]');
    let visible = Math.min(allSelected.length, Math.max(Number(cached?.visible) || 0, Number(root.dataset.initial) || 8));
    const refresh = () => {
      allSelected.forEach((card, index) => { card.hidden = index >= visible; });
      groups.forEach(group => { group.hidden = !allSelected.some(card => card.closest('[data-discovery-group]') === group && !card.hidden); });
      button.hidden = visible >= allSelected.length;
      root.hidden = allSelected.length === 0;
      const latest = readState();
      latest.pages[cacheKey] = {handles: allSelected.map(card => card.dataset.handle), visible};
      saveState(latest);
    };
    refresh();
    root.dataset.discoveryReady = 'true';
    const reveal = () => { visible = Math.min(allSelected.length, visible + (Number(root.dataset.batch) || 8)); refresh(); };
    button.addEventListener('click', () => {
      const previous = visible;
      reveal();
      allSelected[previous]?.querySelector('.sapiato-aov__name')?.focus({preventScroll: true});
    });
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !button.hidden) reveal();
        if (button.hidden) revealObserver.disconnect();
      }, {rootMargin: '200px 0px'});
      if (!button.hidden) revealObserver.observe(button);
      const impressions = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting || entry.intersectionRatio < .35 || entry.target.hidden || entry.target.closest('[data-discovery-group]').hidden) continue;
          const card = entry.target;
          if (!card.dataset.impressed) {
            card.dataset.impressed = 'true';
            const latest = readState();
            latest.seen[card.dataset.handle] = {count: (latest.seen[card.dataset.handle]?.count || 0) + 1, time: Date.now()};
            saveState(latest);
            event(root, 'sapiato_recommendation_impression', card);
          }
          impressions.unobserve(card);
        }
      }, {threshold: .35});
      allSelected.forEach(card => impressions.observe(card));
    }
    root.addEventListener('click', e => {
      const card = e.target.closest('a')?.closest('[data-discovery-card]');
      if (card) event(root, 'sapiato_recommendation_click', card);
    });
  };
  const start = () => document.querySelectorAll('[data-discovery]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
